


































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import BillingCustomerAudit from '@/domain/billing/entity/billing-customer-audit.entity';
import Pagination from '@/domain/pagination.entity';
import toCurrency from '@/shared/directive/toCurrency';
import headers from './audit-datatable-headers.json';

@Component({
  components: { VbPagination },
  filters: { toCurrency },
})
export default class AuditDatatable extends Vue {
  @Prop()
  private customerAudits!: BillingCustomerAudit[];

  @Prop()
  private pagination!: Pagination;

  @Prop({ type: Boolean, default: false })
  private loading!: boolean;

  private headers: any = headers;

  private formatBoolean(prop?: boolean): String {
    if (prop === null || prop === undefined) {
      return '';
    }
    return prop ? 'Sim' : 'Não';
  }

  private updateTable(pagination: Pagination): void {
    this.$emit('updatePagination', pagination);
  }

  private updateSortBy(sortBy: string[]): void {
    this.$emit('updateSortBy', sortBy);
  }

  private updateSortDesc(sortDesc: boolean): void {
    this.$emit('updateSortDesc', sortDesc);
  }
}
